import { task } from 'mobx-task'
import { ModalViewModel } from '@/infra/ModalViewModel'
import {
  hasPendingStripeConnectCode,
  takePendingStripeConnectCode,
} from '@/features/billing/stripe-connect/stripe-connect'

/**
 * Modal shown while finishing the Stripe Connect flow that the Stripe Connect
 * callback route started.
 */
export class StripeConnectCallbackModalViewModel {
  readonly modal = new ModalViewModel()

  /**
   * @param _connectStripe connects the Stripe account for the code
   */
  constructor(
    private readonly _connectStripe: (code: string) => Promise<unknown>,
  ) {}

  /**
   * Whether the Stripe Connect callback left a connection to finish.
   */
  hasPendingConnection() {
    return hasPendingStripeConnectCode()
  }

  /**
   * Takes the pending connection out of storage and connects it while the
   * modal shows the progress.
   */
  connect = task.resolved(async () => {
    this.modal.show()
    await this._connectStripe(takePendingStripeConnectCode())
  })
}
